import { render, staticRenderFns } from "./CallGPT.vue?vue&type=template&id=5f63c81a&"
import script from "./CallGPT.vue?vue&type=script&lang=js&"
export * from "./CallGPT.vue?vue&type=script&lang=js&"
import style0 from "./CallGPT.vue?vue&type=style&index=0&id=5f63c81a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports